(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminClientAdminDisplaySettingsController', AdminClientAdminDisplaySettingsController);

    function AdminClientAdminDisplaySettingsController(
        $controller,
        lodash,
        settingsCollection,
        recurrenceRulesService,
        elbSettings,
        $state,
        module,
        modulesService
    ) {
        const vm = this;
        const base = $controller('AdminDisplaySettingsController', {
            lodash: lodash,
            settingsCollection: settingsCollection,
            settingsFields: [
                'client_admin_domains'
            ],
            recurrenceRulesService: recurrenceRulesService,
            elbSettings: elbSettings,
            $state: $state,
            module: module,
            modulesService: modulesService
        });

        angular.extend(vm, base);
    }
})();
